// ISS-285582: Redux reducer for the Asset Management feature.
// Manage Assets slice (PR-2) lives under `assets`. Hub Configs and
// allocations land in PR-3 / PR-4.

import {
  SET_ACTIVE_TAB,
  FETCH_ASSETS_REQUEST,
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAILURE,
  FETCH_HUB_MAPPINGS_REQUEST,
  FETCH_HUB_MAPPINGS_SUCCESS,
  FETCH_HUB_MAPPINGS_FAILURE,
  FETCH_ALLOCATIONS_REQUEST,
  FETCH_ALLOCATIONS_SUCCESS,
  FETCH_ALLOCATIONS_FAILURE,
  TAB_KEY,
} from './AssetManagement.constants';
import {
  IAssetManagementState,
  IAction,
  IWorkerEquipment,
  IWorkerEquipmentHubMapping,
  IAllocationRow,
} from './AssetManagement.types';

const defaultState: IAssetManagementState = {
  activeTab: TAB_KEY.ALL_ASSIGNMENTS,
  assets: {
    isLoading: false,
    data: [],
    error: null,
  },
  hubMappings: {
    isLoading: false,
    data: [],
    error: null,
  },
  allocations: {
    isLoading: false,
    data: [],
    count: 0,
    error: null,
  },
};

export default function assetManagementReducer(
  state: IAssetManagementState = defaultState,
  action: IAction,
): IAssetManagementState {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload as IAssetManagementState['activeTab'],
      };

    case FETCH_ASSETS_REQUEST:
      return {
        ...state,
        assets: { ...state.assets, isLoading: true, error: null },
      };

    case FETCH_ASSETS_SUCCESS:
      return {
        ...state,
        assets: {
          isLoading: false,
          data: (action.payload as IWorkerEquipment[]) || [],
          error: null,
        },
      };

    case FETCH_ASSETS_FAILURE:
      return {
        ...state,
        assets: {
          ...state.assets,
          isLoading: false,
          error: (action.payload as string) || 'Unknown error',
        },
      };

    case FETCH_HUB_MAPPINGS_REQUEST:
      return {
        ...state,
        hubMappings: { ...state.hubMappings, isLoading: true, error: null },
      };

    case FETCH_HUB_MAPPINGS_SUCCESS:
      return {
        ...state,
        hubMappings: {
          isLoading: false,
          data: (action.payload as IWorkerEquipmentHubMapping[]) || [],
          error: null,
        },
      };

    case FETCH_HUB_MAPPINGS_FAILURE:
      return {
        ...state,
        hubMappings: {
          ...state.hubMappings,
          isLoading: false,
          error: (action.payload as string) || 'Unknown error',
        },
      };

    case FETCH_ALLOCATIONS_REQUEST:
      return {
        ...state,
        allocations: { ...state.allocations, isLoading: true, error: null },
      };

    case FETCH_ALLOCATIONS_SUCCESS: {
      const payload = action.payload as { data: IAllocationRow[]; count: number };
      return {
        ...state,
        allocations: {
          isLoading: false,
          data: payload.data || [],
          count: payload.count || 0,
          error: null,
        },
      };
    }

    case FETCH_ALLOCATIONS_FAILURE:
      return {
        ...state,
        allocations: {
          ...state.allocations,
          isLoading: false,
          error: (action.payload as string) || 'Unknown error',
        },
      };

    default:
      return state;
  }
}
